const gradient_primary = 'linear-gradient(to right, #f91a1a , #f9391a)'
const gradient_secondary = 'linear-gradient(to bottom, #00346b , #25618d)'

module.exports = {
    gradient_primary,
    gradient_secondary
}